import React from 'react';
import { createRoot } from 'react-dom/client';
import Archive from './Archive';
import Single from './Single';
import Application from './Application';

const clientUrl = options.backendUrl;
const client = options.backendUrl + '/graphql';

document.addEventListener( 'DOMContentLoaded', function() {
	const archiveElement = document.getElementById( 'af_archive_inner' );
	const singleElement = document.getElementById( 'af_single' );
	const applicationElement = document.getElementById( 'af_application' );

	if( typeof archiveElement !== 'undefined' && archiveElement !== null ) {
		const root = createRoot(archiveElement);

		root.render(<Archive client={client} />);
	}

	if( typeof singleElement !== 'undefined' && singleElement !== null ) {
		const root = createRoot(singleElement);

		root.render(<Single clientUrl={clientUrl} client={client} apartmentID={parseInt(document.getElementById( 'af_single' ).dataset.id)} />);
	}

	if( typeof applicationElement !== 'undefined' && applicationElement !== null ) {
		const root = createRoot(applicationElement);
		const token = applicationElement.dataset.token;

		root.render(<Application clientUrl={clientUrl} client={client} token={token} />);
	}
} );
